import { createTheme, responsiveFontSizes } from "@mui/material";

const APP_FONT_FAMILY = '"Inter", sans-serif';

export const primaytheme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: "#971243",
      },
      secondary: {
        main: "#00566A", // color secundario
      },
    },
    typography: {
      fontFamily: APP_FONT_FAMILY,
      h1: {
        fontSize: "2rem",
        fontWeight: 700,
      },
      h2: {
        fontSize: "1.75rem",
        fontWeight: 680,
      },
    },
  }),
);


export const mobileTheme = createTheme({
  palette: {
    primary: {
      main: '#971243',
    },
    secondary: {
      main: '#00566A',
    },
  },
  typography: {
    fontFamily: APP_FONT_FAMILY,
    fontSize: 12, // Fuente base más pequeña para móviles
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 680,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 700,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 700,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
    },
    body1: {
      fontSize: '0.875rem',
    },
    body2: {
      fontSize: '0.75rem',
    },
  },
  spacing: 2,
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small', // Por defecto se usará el tamaño pequeño
      },
      styleOverrides: {
        root: {
          // Si es necesario, puedes ajustar el margin u otros estilos del contenedor

        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '8px', // Reduce el padding interno para una apariencia más compacta
        },
      },
    },
    // Si usas otros variantes de Input, puedes aplicar ajustes similares
    MuiInputBase: {
      styleOverrides: {
        input: {
          // Ejemplo adicional para inputs no outlined
          padding: '8px',
        },
      },
    },
        // Mejoras para Tablas
        MuiTableCell: {
          styleOverrides: {
            root: {
              padding: '6px 8px', // Reduce el padding en las celdas para móviles
              fontSize: '0.75rem',
            },
            head: {
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5', // Color de fondo para las cabeceras de tabla
            },
          },
        },
        MuiTable: {
          styleOverrides: {
            root: {
              margin: '8px 0', // Margen reducido para evitar espacios excesivos
            },
          },
        },
  },
});


export const tabletTheme = createTheme({
  palette: {
    primary: {
      main: '#971243',
    },
    secondary: {
      main: '#00566A',
    },
  },
  typography: {
    fontFamily: APP_FONT_FAMILY,
    fontSize: 14, // Fuente base un poco mayor que en móviles
    h1: {
      fontSize: '3.5rem',
      fontWeight: 800,
    },
    h2: {
      fontSize: '2.0rem',
      fontWeight: 680,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 700,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 700,
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 700,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  spacing: 3, // Espaciado intermedio
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small', // Puedes dejarlo en small o probar con medium, según prefieras
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '10px', // Padding un poco mayor que en móviles para mayor comodidad
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '10px',
        },
      },
    },
    // Mejoras para Tablas
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px 10px', 
          fontSize: '0.875rem',
        },
        head: {
          fontWeight: 'bold',
          backgroundColor: '#f5f5f5',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          margin: '10px 0', 
        },
      },
    },

   
  },
});
